import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { Amount } from "models/utilTypes/currencyType";
import { CurrencyEnums } from "models/enums";
import { PausedPaymentListTableProps } from "models/propTypes/paymentPropTypes";
//#endregion
//#region components
import PaymentList from "../paymentListTable";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const PausedPaymentsList: React.FC<PausedPaymentListTableProps> = (props) => {
  const [loadingRows, setLoadingRows] = React.useState<WintSuperkollAPIModel.PausedPayment[]>([]);

  React.useEffect(() => {
    // eslint-disable-next-line eqeqeq --- since checked against different types
    const currentLoadingRows = loadingRows.filter((r) => props.items?.some((i) => i.id == r.id));
    setLoadingRows(currentLoadingRows);
  }, [props.items]);

  return (
    <PaymentList
      properties={{
        dueDate: {
          description: TranslationKeys.Common.Due_Date,
          formatter: (pausedPayment: WintSuperkollAPIModel.PausedPayment) =>
            pausedPayment.dueDate && new Date(pausedPayment.dueDate),
          disableSort: true,
        },
        supplier: {
          description: TranslationKeys.IncomingInvoice.Supplier,
          formatter: (pausedPayment: WintSuperkollAPIModel.PausedPayment) => pausedPayment.supplierName,
          disableSort: true,
        },
        amount: {
          description: TranslationKeys.Common.Amount,
          formatter: (stoppedPayment: WintSuperkollAPIModel.PausedPayment) =>
            new Amount(stoppedPayment.currency ?? CurrencyEnums.CurrencyCode.SEK, stoppedPayment.amount),
          disableSort: true,
          alignment: "right",
          className: cssExports.textBlack,
        },
      }}
      onRowSelectionsChange={props.onRowSelectionsChange}
      items={props.items?.map((i) => ({
        ...i,
        select: props.selectedPayments.some((s) => s.id === i.id),
        loading: loadingRows.some((lr) => lr.id === i.id),
      }))}
    ></PaymentList>
  );
};

export default PausedPaymentsList;
